import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const CalendarApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.CALENDAR}
      scope='calendar'
      envKey={apps[AppId.CALENDAR].runtimeEnvKey}
      entryPath='./CalendarApp'
      url={process.env.REACT_APP_CALENDAR_APP_DEV_PATH}
      appName={apps[AppId.CALENDAR].name}
      appProps={{
        user,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { CalendarApp }
